import { useCallback, useState } from 'react';

import { parseParticipantAux } from '@features/tournament/types';

// Флаг приватной комнаты своего участника: начальное значение из списка участников,
// дальше — событие ParticipantAuxUpdated. Его источник у ПК (хаб пользователя) и у
// телефона (хаб турнира по билету) разный, поэтому событие подает вызывающий
export function usePrivateRoomFlag(
  initial: boolean | undefined,
): [inPrivateRoom: boolean, applyAux: (aux: unknown) => void] {
  const [flag, setFlag] = useState<boolean | null>(null);
  const applyAux = useCallback((aux: unknown) => {
    setFlag(parseParticipantAux(aux).privateVideoRoom === true);
  }, []);
  return [flag ?? initial ?? false, applyAux];
}
